import React from 'react'
import DefaultAvatar from "../../images/default_avatar.jpg"
import { formatDbTime } from '../../../utils/dateFormater'


const SingleConversation = ({
    conversation_id,
    user,
    last_message,
    last_message_at,
    is_last_message_seen,
    conversationID,
    setConversationID,
    setNewUserID,
    setNewUserData,
    isOnline,
}) => {

    return (
        <div 
            className={`flex gap-[1vmax] items-center p-[0.8vmax] rounded-lg cursor-pointer transition-all mb-[0.3vmax] border
                ${conversationID === conversation_id ? "bg-indigo-50/70 border-indigo-100" : "hover:bg-gray-50 border-transparent"}`}
            onClick={() => {
                conversationID === conversation_id ? setConversationID(null) : setConversationID(conversation_id);
                setNewUserID(null);
                setNewUserData({});
            }}
        >
            <div className="relative w-[3vmax] h-[3vmax] flex-shrink-0">
                <div className="w-full h-full rounded-full overflow-hidden border border-gray-100 shadow-sm bg-white">
                    <img src={user?.avatar_url || DefaultAvatar} alt={user?.name} className="w-full h-full object-cover" />
                </div>
                {isOnline && (
                    <div className="absolute bottom-0 right-0 w-[0.8vmax] h-[0.8vmax] rounded-full bg-emerald-500 border-2 border-white"></div>
                )}
            </div>

            {/* Info */}
            <div className="flex-1 min-w-0">
                <div className="flex justify-between items-baseline">
                    <div className="flex items-center gap-[0.5vmax] min-w-0 flex-1">
                        <h3 className={`text-[0.95vmax] font-bold truncate ${conversationID === conversation_id ? "text-indigo-700" : "text-gray-800"}`}>
                            {user?.name}
                        </h3>
                        {user?.role && (
                            <span className="text-[0.6vmax] font-bold px-[0.4vmax] py-[0.1vmax] rounded-full bg-indigo-50 text-indigo-600 uppercase flex-shrink-0">
                                {user?.role}
                            </span>
                        )}
                    </div>
                    <span className="text-[0.75vmax] text-gray-400 font-medium">
                        {formatDbTime(last_message_at)}
                    </span>
                </div>
                <div className="flex justify-between items-center mt-[0.1vmax]">
                    <p className={`text-[0.8vmax] truncate flex-1 ${!is_last_message_seen ? "text-gray-900 font-bold" : "text-gray-500"}`}>
                        {last_message?.message}
                    </p>
                    {!is_last_message_seen && (
                        <div className="w-[0.5vmax] h-[0.5vmax] rounded-full bg-indigo-600 ml-[0.5vmax] flex-shrink-0"></div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default SingleConversation
